<template>
  <div>
    <nav class="navbar is-radiusless" v-click-outside="() => menu = false">
      <div class="navbar-brand">
        <span class="navbar-item oc-logo has-text-weight-bold">Bet'N GO</span>
        <div class="navbar-burger burger" @click="menu = !menu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="navbar-menu" :class="{'is-active': menu}">
        <div class="navbar-start">
          <router-link :to="{name: 'dashboard'}" class="navbar-item" active-class="is-active" exact>
            Dashboard
          </router-link>
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">
              {{ client.name || 'Clients' }}
            </a>
            <div class="navbar-dropdown is-boxed">
              <router-link v-for="c in clients" :key="c.id" :to="{ name: 'players', params: { clientId: c.id } }" active-class="is-active" class="navbar-item">{{c.name}}</router-link>
            </div>
          </div>
          <router-link :to="{ name: 'stats' }" active-class="is-active" class="navbar-item">
            Stats
          </router-link>
          <router-link :to="{ name: 'system-settings' }" active-class="is-active" class="navbar-item">
            System
          </router-link>
          <router-link :to="{ name: 'system-content' }" active-class="is-active" class="navbar-item">
            Content
          </router-link>
          <router-link :to="{ name: 'system-mbk' }" active-class="is-active" class="navbar-item">
            MBK
          </router-link>
        </div>
        <div class="navbar-end">
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">
              <span class="icon has-text-grey-light">
                <i class="fas fa-user" aria-hidden="true"></i>
              </span>
              <span class="user-name">{{ adminUsername }}</span>
            </a>
            <div class="navbar-dropdown is-boxed">
              <a @click="logout" class="navbar-item">
                <span class="icon has-text-grey-light">
                  <i class="fas fa-sign-out-alt"></i>
                </span>
                <span>Logout</span>
              </a>
            </div>
          </div>
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">
              {{adminTimezone.description}}
            </a>
            <div class="navbar-dropdown is-right">
              <a v-for="tz in timezones" :key="tz.id" class="navbar-item" :class="{'is-active':adminTimezone.id == tz.id}" @click="adminTimezone = tz">
                {{tz.description}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="tabs" v-if="clientId">
      <ul>
        <router-link tag="li" :to="{ name: 'players', params: { clientId: client.id } }" active-class="is-active">
          <a>Players</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'client-warn-transactions', params: { clientId: client.id } }" active-class="is-active">
          <a>Warning transactions</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'client-pins', params: { clientId: client.id } }" active-class="is-active">
          <a>Pins</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'client-bets', params: { clientId: client.id } }" active-class="is-active">
          <a>Bets</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'payment-system', params: { clientId: client.id } }" active-class="is-active">
          <a>Payment System</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'client-bonuses-playthrough', params: { clientId: client.id } }" active-class="is-active">
          <a>Bonuses</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'client-jackpots', params: { clientId: client.id } }" active-class="is-active">
          <a>Jackpots</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'client-settings-general', params: { clientId: client.id } }" active-class="is-active">
          <a>Settings</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'client-content-strings', params: { clientId: client.id } }" active-class="is-active">
          <a>Content</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'client-games-general', params: { clientId: client.id } }" active-class="is-active">
          <a>Games</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'branch-list', params: { clientId: client.id } }" active-class="is-active">
          <a>Branches</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'client-messages', params: { clientId: client.id } }" active-class="is-active">
          <a>Messages</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'agents', params: { clientId: client.id } }" active-class="is-active">
          <a>Agents</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'client-curacao-balance-reports', params: { clientId: client.id } }" active-class="is-active">
          <a>Curacao</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'client-kra-payments', params: { clientId: client.id } }" active-class="is-active">
          <a>KRA</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
  import userService from '../services/user.service'
  import clientService from '../services/client.service'
  import currencyService from '../services/currency.service'
  import timezoneService from '../services/timezone.service'
  import state from '../state'

  export default {
    name: 'topbar',
    data() {
      return {
        menu: false
      }
    },
    computed: {
      clients() {
        return state.clients.get();
      },
      clientId() {
        return Number(this.$route.params.clientId);
      },
      client() {
        return state.clients.getClient(this.clientId);
      },
      adminUsername() {
        return state.admin.get() && state.admin.get().username;
      },
      timezones() {
        return state.timezones.get();
      },
      adminTimezone: {
        get() {
          return state.adminTimezone.get();
        },
        set(val) {
          state.adminTimezone.set(val);
        }
      }
    },
    methods: {
      async logout() {
        await userService.logout();
        state.admin.unset();
        clientService.unset();
        currencyService.unset();
        timezoneService.unset();
        this.$router.push({ name: 'login' });
      }
    }
  }
</script>
<style scoped>
  .oc-logo {
    color: #090910 !important;
  }
  .user-name {
    margin-right: 8px;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// front/src/components/topbar.vue